import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from "classnames";

import SlidePreview from "Components/SlidePreview";

const classes = {
    container: 'flex flex-grow overflow-y-scroll space-x-2'
};

class StoryCardSlideList extends React.Component
{
    static propTypes = {
        storyId: PropTypes.string.isRequired,
        slides: PropTypes.array.isRequired,
        elements: PropTypes.object.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        className: ''
    };

    render()
    {
        if (this.props.slides.length < 1) {
            return null;
        }

        return <div className={classNames(classes.container, this.props.className)}>
            {
                this.props.slides.map(slide => <div className='inline-block -mr-1'>
                    <SlidePreview scale={0.2} slide={slide} />
                </div>)
            }
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {

    const slides = _.filter(state.slides, ['story_id', ownProps.storyId]);

    return {
        slides: _.orderBy(slides, ['position']),
        elements: state.elements, // urgh... using this when building <Properties/>
    };
};

export default connect(
    mapStateToProps,
    null
)(StoryCardSlideList);